import { DateTime } from "luxon"

import { getDataPointIntervals } from "@/features/datapoints/api/getDataPointIntervals.ts"
import type { DataPointValue } from "@/types/dataPointTypes.ts"

import type { FlowChartDataPoint } from "../../types/flowChartTypes.ts"

export const getFlowChartData = async (): Promise<FlowChartDataPoint[]> => {
  const startDate = DateTime.now().minus({ days: 1 }).toJSDate()
  const endDate = DateTime.now().minus({ seconds: 1 }).toJSDate()
  const interval = 1800
  const responses = await Promise.all([
    getDataPointIntervals(17, { start: startDate, end: endDate, interval, aggMode: "Average" }),
    getDataPointIntervals(11, { start: startDate, end: endDate, interval, aggMode: "Average" }),
    getDataPointIntervals(18, { start: startDate, end: endDate, interval, aggMode: "Average" }),
    getDataPointIntervals(13, { start: startDate, end: endDate, interval, aggMode: "Average" }),
  ])

  const [inlet, outlet, inletCH4, outletCH4]: DataPointValue[][] = responses

  return inlet.map((val, i) => ({
    timestamp: DateTime.fromISO(val.timestamp)
      .plus({ seconds: interval })
      .toLocaleString(DateTime.TIME_SIMPLE),
    inlet: val.value || 0,
    methane: (val.value || 0) * ((inletCH4[i]?.value || 0) / 100),
    outlet: (outlet[i]?.value || 0) * ((outletCH4[i]?.value || 0) / 100),
  }))
}
